import { createContext, useContext, useMemo, useState } from 'react';
import { ReorderSteps } from '../../../sweep-canvas/reorder-steps-mode/ReorderStepsCtx';

interface UnitedSweepCanvasReorderCtxType {
  reorderStepsMode?: ReorderSteps;
  setReorderStepsMode: React.Dispatch<React.SetStateAction<ReorderSteps | undefined>>;
}

const UnitedSweepCanvasReorderCtx = createContext<UnitedSweepCanvasReorderCtxType>({
  setReorderStepsMode: () => {},
});

export const UnitedSweepCanvasReorderCtxProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [reorderStepsMode, setReorderStepsMode] = useState<ReorderSteps>();

  return (
    <UnitedSweepCanvasReorderCtx.Provider value={{ reorderStepsMode, setReorderStepsMode }}>
      {children}
    </UnitedSweepCanvasReorderCtx.Provider>
  );
};

export const useUnitedSweepCanvasReorderCtx = () => {
  const context = useContext(UnitedSweepCanvasReorderCtx);
  if (!context) {
    throw new Error(
      'useUnitedSweepCanvasReorderCtx must be used within a UnitedSweepCanvasReorderCtxProvider',
    );
  }
  return useMemo(
    () => ({
      ...context,
      isReorderStepsModeActive: !!context.reorderStepsMode,
    }),
    [context],
  );
};
